module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles